module.exports = __webpack_public_path__ + "img/hnlg.8c23a5f2.png";